var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#WarningIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E03757",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04760",
    d: "M5.63 18.723c7.214 0 13.062-5.848 13.062-13.061a13 13 0 0 0-.63-4.021A11.94 11.94 0 0 0 12 0C5.373 0 0 5.373 0 12a11.94 11.94 0 0 0 1.673 6.113 13 13 0 0 0 3.957.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.995 20.14a1.95 1.95 0 1 1 0-3.9 1.95 1.95 0 0 1 0 3.9m1.89-6.717a1.3 1.3 0 0 1-.385.794c-.22.214-.504.347-.81.378h-.008a5 5 0 0 1-.576.033 7 7 0 0 1-.69-.033h-.01a1.35 1.35 0 0 1-.808-.378 1.3 1.3 0 0 1-.385-.794c-.047-.44-.07-3.497-.07-4.178s.023-3.746.07-4.186c.032-.303.168-.584.385-.797a1.36 1.36 0 0 1 .809-.378h.009q.345-.034.69-.022.289-.012.576.022h.009c.305.032.59.167.809.382.217.213.353.494.385.796.047.44.07 3.506.07 4.186s-.023 3.736-.07 4.175"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "WarningIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWarningIcon;